/* Restore the filter trigger after the existing drawer closes on Collection and Search. */
(() => {
  const init = () => {
    const drawer = document.getElementById('Facet-Drawer');
    const trigger = document.getElementById('Facets-Toggle');
    if (!drawer || !trigger) return;

    trigger.tabIndex = 0;
    trigger.setAttribute('role', 'button');
    trigger.setAttribute('aria-controls', 'Facet-Drawer');

    const syncExpandedState = () => {
      trigger.setAttribute('aria-expanded', String(!drawer.hasAttribute('inert')));
    };

    const restoreTriggerFocus = () => {
      let attempts = 0;
      const waitForClose = () => {
        if (drawer.hasAttribute('inert') && trigger.isConnected) {
          trigger.focus();
          return;
        }
        attempts += 1;
        if (attempts < 12) window.setTimeout(waitForClose, 50);
      };
      window.setTimeout(waitForClose, 50);
    };

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !drawer.hasAttribute('inert')) restoreTriggerFocus();
    }, true);

    drawer.querySelector('side-panel-close')?.addEventListener('click', restoreTriggerFocus);
    trigger.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        trigger.click();
      }
    });

    new MutationObserver(syncExpandedState).observe(drawer, { attributes: true, attributeFilter: ['inert'] });
    syncExpandedState();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
